<figure>
  <air-focal-image [image]="content.image"></air-focal-image>
  <figcaption *ngIf="content.caption">{{ content.caption }}</figcaption>
</figure>
